import React from 'react';
import styles from './css/index.module.css';

const AiWardenGapsPanel = ({ onSubmit, submitting }) => {
    return (
        <>
            <p className={styles.aiWardenTip}>
                Identify evidence gaps, weak support, and areas needing further validation in the selected scope using retrieved evidence only.
            </p>
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Find Gaps'}
                </button>
                <span className={styles.aiWardenTip}>Output uses only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenGapsPanel;
